import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSliders } from "@fortawesome/pro-solid-svg-icons/faSliders";
import { kebabCase } from "@portal/app/_common/lib/changeCase";

import { OnlineClassesFilterPill } from "./OnlineClassesFilterPill";
import { FinancialAidFilterPill } from "./FinancialAidFilterPill";
import { PaymentPlanFilterPill } from "./PaymentPlanFilterPill";
import { CertificateFilterPill } from "./CertificateFilterPill";
import { useEffect, useMemo, useState } from "react";
import { DirectPatientCareFilterPill } from "./DirectPatientCareFilterPill";
import { Duration90DaysFilterPill } from "@portal/app/health/_components/components/filter/Duration90DaysFilterPill";
import { usePageContext } from "@portal/app/_components/context/PageContext";
import { AppliedFilterChips } from "./AppliedFilterChips";

export const DreamSearchFilterPills = ({ onPillClick }: { onPillClick: () => void }) => {
  const { isDesktop } = usePageContext();
  const [isInteractive, setIsInteractive] = useState(false);

  // Results can be visible in the server HTML before React attaches the click
  // handler. Keep Filters disabled until hydration so the first click opens it.
  // This guards the dialog trigger; featured toggles are tracked in ENG-10907.
  useEffect(() => {
    setIsInteractive(true);
  }, []);

  const featuredFilters = useMemo(
    () =>
      [
        <OnlineClassesFilterPill key="online-classes" />,
        <FinancialAidFilterPill key="financial-aid" />,
        <PaymentPlanFilterPill key="payment-plan" />,
        <CertificateFilterPill key="certificate" />,
        <DirectPatientCareFilterPill key="direct-patient-care" />,
        <Duration90DaysFilterPill key="90-days" />,
      ].slice(0, isDesktop ? 6 : 2),
    [isDesktop]
  );

  return (
    <>
      <PillsCarouselWrapper>
        {featuredFilters}
        <Chip
          label="Filters"
          icon={<FontAwesomeIcon icon={faSliders} />}
          variant="outlined"
          disabled={!isInteractive}
          sx={{ height: "3rem", px: 1 }}
          onClick={() => {
            onPillClick();
          }}
          data-testid={kebabCase(`dream-search-filter-more-options`)}
        />
      </PillsCarouselWrapper>
      <AppliedFilterChips />
    </>
  );
};

const PillsCarouselWrapper = styled(Box)`
  display: flex;
  overflow-x: scroll;
  align-items: center;
  padding: 1rem 0;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 2rem 0;
  }

  scrollbar-width: none;
  // Hide scrollbar on Safari

  &::-webkit-scrollbar {
    display: none;
  }
`;
